'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420 from "./presto.-Dashboard-View$$anon$20.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024 from "./presto.types$-Dashboard-User-Stats$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024 from "./presto.types$-User-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$19() {
  this.aK8 = null;
  this.aK0 = null;
  this.aK1 = false;
  this.aK9 = null;
  this.aKa = false;
  this.aKd = null;
  this.aK6 = null;
  this.aK7 = false;
  this.aK2 = null;
  this.aK3 = false;
  this.aK4 = null;
  this.aK5 = false;
  this.aKb = false;
  this.aKc = false;
  this.aK8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKd = "DashboardUserStats";
}
export { $c_Lpresto_DashboardView$$anon$19 as $c_Lpresto_DashboardView$$anon$19 };
$p = $c_Lpresto_DashboardView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$19;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$19() {
}
export { $h_Lpresto_DashboardView$$anon$19 as $h_Lpresto_DashboardView$$anon$19 };
$h_Lpresto_DashboardView$$anon$19.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aK8;
});
$p.L = (function() {
  if ((!this.aK1)) {
    this.aK0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aK1 = true;
  }
  return this.aK0;
});
$p.O = (function() {
  if ((!this.aKa)) {
    this.aK9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKa = true;
  }
  return this.aK9;
});
$p.E = (function() {
  return this.aKd;
});
$p.t = (function() {
  if ((!this.aK7)) {
    this.aK6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aK7 = true;
  }
  return this.aK6;
});
$p.M = (function() {
  if ((!this.aK3)) {
    this.aK2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dId$0024.$m_Lpresto_types$UserId$().jU(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aK3 = true;
  }
  return this.aK2;
});
$p.Q = (function() {
  if ((!this.aK5)) {
    this.aK4 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002420.$c_Lpresto_DashboardView$$anon$20();
    this.aK5 = true;
  }
  return this.aK4;
});
$p.w = (function() {
  if ((!this.aKc)) {
    this.aKb = false;
    this.aKc = true;
  }
  return this.aKb;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee95) => ((p) => \u03b4scrutinee95.cGr(p)))($j_presto$002etypes$0024$002dDashboard$002dUser$002dStats$0024.$m_Lpresto_types$DashboardUserStats$())));
});
var $d_Lpresto_DashboardView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$19, "presto.DashboardView$$anon$19", ({
  GK: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$19 as $d_Lpresto_DashboardView$$anon$19 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$19.js.map
